import * as app from "./app";
import * as auth from "./auth";
import * as model from "./model";
import * as folder from "./folder";
import * as user from "./user";
import * as modelExport from "./modelExport";

export default {
  app,
  auth,
  model,
  folder,
  modelExport,
  user
};



// WEBPACK FOOTER //
// ./src/services/firebase/index.js